import { render, staticRenderFns } from "./SuccessSubmitManualForm.vue?vue&type=template&id=3bfde2c2&scoped=true"
import script from "./SuccessSubmitManualForm.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitManualForm.vue?vue&type=script&lang=ts"
import style0 from "./SuccessSubmitManualForm.vue?vue&type=style&index=0&id=3bfde2c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfde2c2",
  null
  
)

export default component.exports